
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {};
  url = "/api/corp/config/get";
  name = "";
  country = "";
  year = "";
  filterUrl = "";
  page = 1;
  on = null;
  date = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }
  async save() {
    try {
      common.setLoading(true);

      await doPost("/api/corp/config/route/save", this.corporateConfig);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
